import * as React from 'react'
import { Redirect, RouteComponentProps } from 'react-router-dom'
import Select from 'react-select'
import { ISaveVehicleAccommodations, IVehicleObj } from '../../../types/vehicle'
import { MessageTopBar, messageTypes } from '../../ui/entity/MessageTopBar'
import AccommodationTag from './AccommodationTag'
import EditBottom from '../../vehicles/edit-vehicle/EditBottom'

interface IAccommodationOption {
  value: string
  label: string
  accommodation: IAccommodation
}

interface IAccommodation {
  id: string
  name: string
}

export interface ISelectedAccommodation {
  accommodationId: string
  name: string
  number: number
}

interface IAccommodationsProps extends RouteComponentProps<{ id: string }> {
  accommodations: IAccommodation[]
  isLoading: boolean
  requesting: boolean
  error: string
  currentVehicle: IVehicleObj
  isSaved: boolean
  setVehicleSavedStateToInitial: () => void
  getAccommodations: () => void
  updateVehicleAccommodations: (data: ISaveVehicleAccommodations) => void
  getVehicleById: (id: string) => void
}

interface IAccommodationsState {
  selectedAccommodations: { [id: string]: ISelectedAccommodation }
  isError: boolean
  redirectAfterSave: boolean
  isSaved: boolean
  isSaving: boolean
}

class Accommodations extends React.Component<IAccommodationsProps, IAccommodationsState> {
  private id: any

  constructor(props: IAccommodationsProps) {
    super(props)
    this.state = {
      selectedAccommodations: {},
      isError: false,
      redirectAfterSave: false,
      isSaved: false,
      isSaving: false
    }
  }

  public componentDidMount() {
    this.props.getAccommodations()
    this.props.getVehicleById(this.props.match.params.id)
    this.populateFromVehicle()
  }

  public componentWillMount() {
    this.props.setVehicleSavedStateToInitial()
  }

  public componentDidUpdate(prevProps: IAccommodationsProps) {
    if (this.props.isSaved) {
      this.props.history.push(`/vehicles/view/${prevProps.currentVehicle.id}/accommodations`)
    }

    if (JSON.stringify(prevProps.currentVehicle) !== JSON.stringify(this.props.currentVehicle)) {
      this.populateFromVehicle()
    }
  }

  public componentWillUnmount() {
    clearTimeout(this.id)
  }

  public render() {
    const { isSaved, isSaving } = this.state

    if (!this.props.accommodations && this.props.currentVehicle) {
      return <div>Wait</div>
    }

    const selectedAccommodations = Object.values(this.state.selectedAccommodations)
    return (
      <div className='pt2'>
        <div className='ml3'>
          <div className='bold'>Accommodations</div>
          <MessageTopBar type={messageTypes.ERROR} isActive={this.state.isError}>
            Fill all fields!
          </MessageTopBar>
          <div className='col-4 mt2'>
            <div className='h6'>Add an accommodation</div>
            <Select options={this.getAccommodationOptions(this.props.accommodations)} onChange={this.onSelect} />
          </div>
          {!!selectedAccommodations.length && (
            <div className='mt2'>
              <div className='h6'>Existing vehicle accommodations</div>
              <div className='flex col-4'>
                {selectedAccommodations.map((accommodation: ISelectedAccommodation) => (
                  <AccommodationTag
                    key={accommodation.accommodationId}
                    accommodation={accommodation}
                    handleRemove={this.handleRemove}
                    handleSelectAmount={this.handleSelectAmount}
                  />
                ))}
              </div>
            </div>
          )}
        </div>
        <div className='absolute bottom-0 w100'>
          {isSaved ? (
            <div className='w100 p2 bg-green font-white bold fs-14 center border-box'>
              Vehicle {this.props.currentVehicle.make} {this.props.currentVehicle.model} has been successfully updated
            </div>
          ) : (
            <EditBottom
              isSaving={isSaving}
              cancelPath={`/vehicles/view/${this.props.currentVehicle.id}/accommodations`}
              onSave={this.onSubmit}
            />
          )}
        </div>
      </div>
    )
  }

  private handleSelectAmount = (id: string, value: number) => {
    const selectedAccommodations = { ...this.state.selectedAccommodations }
    const accommodation = selectedAccommodations[id]
    accommodation.number = value
    this.setState({ selectedAccommodations })
  }

  private onSubmit = () => {
    const selectedAccommodations = Object.values(this.state.selectedAccommodations)

    const withZeros = selectedAccommodations.filter(item => item.number === 0)
    if (withZeros.length > 0) {
      alert('Please enter quantity in ' + withZeros[0].name)

      this.setState({
        isSaved: false
      })

      return
    }

    this.props.updateVehicleAccommodations({
      id: this.props.match.params.id,
      accommodations: selectedAccommodations.map(it => {
        const { name, ...rest } = it
        return rest
      })
    })

    this.setState({
      isSaved: true
    })
  }

  private onSelect = (opt: any) => {
    const accommodation = {
      number: 0,
      accommodationId: opt.accommodation.id,
      name: opt.accommodation.name
    }
    const accommodations = { ...this.state.selectedAccommodations }
    accommodations[accommodation.accommodationId] = accommodation
    this.setState({
      selectedAccommodations: accommodations,
      isError: false
    })
  }

  private getAccommodationOptions = (accommodations: IAccommodation[]) => {
    const selectedAccommodations = Object.values(this.state.selectedAccommodations)
    return accommodations
      .filter((accommodation: IAccommodation) =>
        selectedAccommodations.every((it: ISelectedAccommodation) => it.accommodationId !== accommodation.id)
      )
      .map((accommodation: IAccommodation) => ({
        label: accommodation.name,
        value: accommodation.name,
        accommodation
      }))
  }

  private handleRemove = (accommodationId: string) => {
    const accommodations = { ...this.state.selectedAccommodations }
    delete accommodations[accommodationId]
    this.setState({
      selectedAccommodations: accommodations
    })
  }

  private populateFromVehicle = () => {
    if (!this.props.currentVehicle) {
      return
    }
    const accommodations = {}
    this.props.currentVehicle.accommodations.forEach(a => (accommodations[a.accommodationId] = a))
    this.setState({
      selectedAccommodations: accommodations
    })
  }
}

export default Accommodations



// WEBPACK FOOTER //
// ./src/components/vehicles/edit-vehicle/Accommodations.tsx